module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/pc/item_03_40fc9eae648d71e0e7acd11b7732156d.jpg";